import { ceil, toInteger } from 'lodash';
import url from 'url';

export const offsetFormatToPageFormat = ({
  previous,
  next,
  count,
}: API$Pages): {
  last: AH$Page;
  limit: number;
  selectedPage: number;
} => {
  const { query: nextQuery = {} } = url.parse(next || '', true);
  const { query: prevQuery = {} } = url.parse(previous || '', true);
  const nextLimit = toInteger(nextQuery.limit);
  const nextOffset = toInteger(nextQuery.offset);
  const limit = nextLimit || toInteger(prevQuery.limit);

  return {
    selectedPage: limit ? ceil((nextOffset || count) / limit) : 1,
    last: { page: limit ? ceil(count / limit) : 1 },
    limit,
  };
};
